import { ActionsButtons } from "lib/common";
import DataStatuses from "const/DataStatuses";
import DocumentRecogniseStatuses from "const/DocumentRecogniseStatuses";
import React from "react";

const ActionsCell = (props) => {
  const {
    id,
    status,
    attachmentKey,
    recogniseStatus,
    disabledApprove,
    onDocumentDownload,
    onDocumentEdit,
    onDocumentDelete,
    onDocumentApprove
  } = props;

  const extractStatus = status === DataStatuses.TO_EXTRACT;

  const errorState = recogniseStatus === DocumentRecogniseStatuses.ERROR;

  return (
    <ActionsButtons
      itemId={id}
      disabledDownload={!attachmentKey}
      disabledEdit={extractStatus}
      disabledDelete={extractStatus && !errorState}
      disabledApprove={disabledApprove}
      onDownload={onDocumentDownload}
      onEdit={onDocumentEdit}
      onDelete={onDocumentDelete}
      onApprove={onDocumentApprove} />
  );
};

export default React.memo(ActionsCell);
